module.exports = __webpack_public_path__ + "static/media/Commercial-14.8318ac5c.jpg";